import React, { useEffect, useState } from "react";

interface Payment {
  title: string;
  week: number;
  paidAt: string;
  amount: number;
}

const TableroPage = () => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("id");

  const [isLoading, setIsLoading] = useState(true);
  const [payments, setPayments] = useState<Payment[]>([]);
  const [record, setRecord] = useState<any>(null);

  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/record`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setRecord(data[0]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar detalles del expediente:", error);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/payment/${userId}/payments`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setPayments(data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error al obtener pagos:", err);
        setIsLoading(false);
      });
  }, []);

  const formatDate = (isoDate: string) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("es-MX", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div className="h-full w-full px-4 sm:px-8">
      <div className="flex flex-col items-start gap-6">
        <h2 className="font-playfair font-bold text-3xl sm:text-4xl mt-12">Tu expediente</h2>
        {isLoading ? (
          <p className="font-sourceSans">Cargando...</p>
        ) : record ? (
          <div className="w-full bg-[#f8f8f8] rounded-md shadow-lg font-sourceSans flex flex-col gap-6 pt-8 px-4 sm:px-8 pb-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex flex-col gap-4 items-start">
                <div>
                  <p className="font-semibold text-base sm:text-lg">Correo electrónico</p>
                  <p className="bg-[#EFEFEF] rounded-md px-2 py-1 break-all">{record.userId.email}</p>
                </div>
                <div>
                  <p className="font-semibold text-base sm:text-lg">Nombre completo</p>
                  <p className="bg-[#EFEFEF] rounded-md px-2 py-1">{record.userId.name}</p>
                </div>
                <div>
                  <p className="font-semibold text-base sm:text-lg">Número de teléfono</p>
                  <p className="bg-[#EFEFEF] rounded-md px-2 py-1">{record.phoneNumber}</p>
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div>
                  <p className="font-semibold text-base sm:text-lg">Dirección</p>
                  <p className="bg-[#EFEFEF] rounded-md px-2 py-1">{record.address}</p>
                </div>
                <div>
                  <p className="font-semibold text-base sm:text-lg">Fecha de inicio</p>
                  <p className="bg-[#EFEFEF] rounded-md px-2 py-1">{record.startDate}</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-6">
              {["ine", "curpImage", "birthCertificate", "highSchoolCertificate", "welcomeLetter"].map((key) => {
                const file = record?.documents?.[key];
                if (!file) return null;

                const fileNameMap: Record<string, string> = {
                  ine: "INE",
                  curpImage: "CURP",
                  birthCertificate: "Acta de Nacimiento",
                  highSchoolCertificate: "Certificado de Secundaria",
                  welcomeLetter: "Carta de Bienvenida",
                };

                const fileUrl = `https://guiascontainer.s3.us-east-2.amazonaws.com/${file}`;
                const isPdf = file.endsWith(".pdf");

                return (
                  <div key={key}>
                    <p className="font-semibold mb-2 text-base sm:text-lg">{fileNameMap[key]}</p>
                    {isPdf ? (
                      <iframe
                        src={fileUrl}
                        className="w-full h-64 rounded border"
                        title={key}
                      />
                    ) : (
                      <img
                        src={fileUrl}
                        alt={key}
                        className="w-full h-64 object-contain rounded border"
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <p className="font-sourceSans">No tienes expediente registrado aún.</p>
        )}

        <h2 className="font-playfair font-bold text-3xl sm:text-4xl mt-12">Pagos realizados</h2>
        <div className="w-full flex flex-col mt-4 gap-4">
          {isLoading ? (
            <p>Cargando pagos...</p>
          ) : payments.length > 0 ? (
            payments.map((p, i) => (
              <div
                key={i}
                className="flex flex-col sm:flex-row sm:justify-between border-y border-gray-600 py-2"
              >
                <p className="font-sourceSans px-3 text-sm sm:text-base">
                  Pagaste el módulo <strong>{p.title}</strong> correspondiente a la <strong>semana {p.week}</strong> el día <strong>{formatDate(p.paidAt)}</strong>. Monto: <strong>${p.amount} MXN</strong>
                </p>
              </div>
            ))
          ) : (
            <p>No has realizado pagos todavía.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableroPage;
